import { Component, Input, OnDestroy } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { StorageService } from '../../../../core/storage/storageService';
import { NavMenuItem } from '../../../../models/ui/navMenuItem';

@Component({
  selector: 'app-secondary-nav',
  templateUrl: './secondary-nav.component.html',
  standalone: false,
})
export class SecondaryNavComponent implements OnDestroy {
  @Input() menu: string = '';

  menuItems: NavMenuItem[] = [];

  public navObserver: Subscription | undefined;

  public selectedId: string = '';

  constructor(
    private storageService: StorageService,
    router: Router,
  ) {
    router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {
        this.setSelectedNavItem(val.url);
      }
    });

    this.setSelectedNavItem(router.url);

  }

  ngOnInit() {
    this.menuItems = this.storageService.getCurrentNav(this.menu);

    this.navObserver = this.storageService.currentNavObservable.subscribe(
      (data) => {
        if (data) {
          this.menuItems = data;
        } else {
          this.menuItems = [];
        }
      },
    );
  }

  ngOnDestroy() {
    this.navObserver?.unsubscribe();
  }

  private setSelectedNavItem(url: string) {
    this.selectedId = url.replace('/', '');
  }

  public getIdAsSelector(id: string): string {
    return id.replaceAll('.', '_').replace('-', '_');
  }

  public getMenuItems() {
    return this.storageService.getCurrentNav(this.menu);
  }

  // We need this or else click events on the nav-icons aren't registered.
  // Don't ask me. Ask Angular.
  public trackById(item: any): string {
    return item.id;
  }
}
